export class UserModel {
    user_id?: number;
    username: string;
    password_hash?: string;
    email: string;
    created_at?: Date;
    updated_at?: Date;
    uuid?: string;
    user_role?: string;

    constructor(data: UserModel) {
        this.user_id = data.user_id;
        this.username = data.username;
        this.password_hash = data.password_hash;
        this.email = data.email;
        this.created_at = data.created_at;
        this.updated_at = data.updated_at;
        this.uuid = data.uuid;
        this.user_role = data.user_role;
    }
}

export class GetUser {
    user_id?: number;
    username: string;
    email: string;
    user_role?: string;

    constructor(data: GetUser) {
        this.user_id = data.user_id;
        this.username = data.username;
        this.email = data.email;
        this.user_role = data.user_role;
    }
}


export class SendUserData {
    email: string;

    constructor(data: SendUserData) {
        this.email = data.email;
    }
}

export interface UserReport {
    status?: string;
    assigned_at?: string;
    status_reviewer?: string;
    assigned_at_reviewer?: string;
}

export interface UserWithReports {
    user_id: number;
    username: string;
    reports: UserReport[];
}

